module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1527-aacb19f92cd3e6434af52e7f2c399fca.png";